// On-demand invoice preview — used only for a booking that hasn't
// generated its static invoice PDF yet (a checked-out booking links
// directly to that pre-generated static file instead, which needs no
// auth). This route sits behind admin auth, so it needs a real fetch with
// the auth header rather than a plain <a href> (which can't attach one).
export async function openInvoicePreview(bookingId, authHeaders, apiBase) {
  try {
    const res = await fetch(`${apiBase}/invoices/${bookingId}`, { headers: authHeaders() });
    if (!res.ok) throw new Error("Failed to load invoice");
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  } catch {
    alert("Couldn't load the invoice preview. Please try again.");
  }
}
